function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 20.004a5.5 5.5 0 100-11 5.5 5.5 0 100 11zm0-1a4.5 4.5 0 110-9 4.5 4.5 0 010 9z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.474 18.686l3.172 3.172a.5.5 0 00.707-.707l-3.172-3.172a.5.5 0 00-.707.707zM9 .882L15.809 14.5H2.191L9 .882zm0 2.236L3.809 13.5h10.382L9 3.118z"
});

function SvgMdDeltaDetected(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "mdDeltaDetected.8174f.svg";
export { SvgMdDeltaDetected as ReactComponent };